export class ToolBase {
  constructor(
    public companyId?: string,
    public serialNumber?: string,
  ) {}
}
